module.exports = __webpack_public_path__ + "static/media/astronomy-not-enrolled.5754946c.svg";